<template>
  <main class="px-8 pb-20">
    <!-- Horizontal Scrollable Wrapper -->
    <div class="overflow-x-auto overflow-y-hidden py-6 scroll-wrapper">
      <!-- Grid Container: 2 rows, 4 columns -->
      <div
        class="grid grid-cols-4 grid-rows-2 gap-6 min-w-[1024px] sm:min-w-[1200px] lg:min-w-[1600px]"
      >
        <div
          v-for="(image, index) in images"
          :key="index"
          class="strategic-card snap-item relative h-80 rounded-lg overflow-hidden shadow-lg cursor-pointer"
        >
          <!-- Background Image -->
          <div
            class="absolute inset-0 bg-cover bg-center"
            :style="`background-image: url(${image.image})`"
          ></div>

          <!-- Overlay -->
          <div class="absolute inset-0 bg-black bg-opacity-75"></div>

          <!-- Text Content -->
          <div
            class="relative z-10 flex flex-col items-center justify-center h-full text-white text-center px-4 top-16"
          >
            <h2 class="text-2xl font-semibold mb-4">{{ image.title }}</h2>
            <router-link
              :to="image.link"
              :class="`${image.buttonColor} hover:bg-white hover:text-black text-white px-8 py-2 rounded-full transition-all border-2 border-transparent`"
            >
              <span class="text-base">Visit</span>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  data() {
    return {
      images: [
        {
          image: require("../assets/images/MHS_1.jpg"),
          title: "Mshel Homes",
          buttonColor: "bg-[#4285F4]",
          link: "/mshel-homes",
        },
        {
          image: require("../assets/images/mshel-print.jpg"),
          title: "Mshel Prints",
          buttonColor: "bg-pink-300",
          link: "/mshel-prints",
        },
        {
          image: require("../assets/images/construction.jpg"),
          title: "Mshel Blocks & Machineries",
          buttonColor: "bg-green-300",
          link: "/mshel-blocks",
        },
        {
          image: require("../assets/images/lisa-suites.jpg"),
          title: "Lisa Suites",
          buttonColor: "bg-teal-300",
          link: "/lisa-suites",
        },
        {
          image: require("../assets/images/pitch-your-dream1.jpg"),
          title: "Mshel Foundation",
          buttonColor: "bg-yellow",
          link: "/mshel-foundation",
        },
        {
          image: require("../assets/images/construction-hero.jpg"),
          title: "Mshel Construction",
          buttonColor: "bg-purple-300",
          link: "/mshel-construction",
        },
        {
          image: require("../assets/images/BAR03773.png"),
          title: "Mshel Consult",
          buttonColor: "bg-red-300",
          link: "/mshel-consult",
        },
        {
          image: require("../assets/images/mshelprints.jpg"),
          title: "Mshel Logistics",
          buttonColor: "bg-indigo-300",
          link: "/mshel-logistics",
        },
      ],
    };
  },
  mounted() {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("fade-in");
          } else {
            entry.target.classList.remove("fade-in");
          }
        });
      },
      {
        threshold: 0.2, // Adjust for smoother animation trigger
      }
    );

    document
      .querySelectorAll(".strategic-card")
      .forEach((card) => observer.observe(card));
  },
};
</script>

<style scoped>
.strategic-card {
  opacity: 0;
  transform: translateY(50px);
  transition: opacity 0.3s ease-out, transform 0.3s ease-out;
  will-change: opacity, transform;
}

.strategic-card.fade-in {
  opacity: 1;
  transform: translateY(0);
}

.strategic-card:hover {
  transform: scale(1.03);
  /* box-shadow: 0 15px 30px rgba(0, 0, 0, 0.2); */
  transition: transform 0.4s ease-out, box-shadow 0.4s ease-out;
  /* background-color: inherit !important; */
  box-shadow: none !important;
}

/* Add these styles to enhance scroll behavior */
.scroll-wrapper {
  scroll-snap-type: x mandatory;
  scroll-behavior: smooth;
}

.snap-item {
  scroll-snap-align: start;
}
</style>
